/** Dashboard → backend. Every call carries a fresh App Bridge session token. */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

async function sessionToken(): Promise<string> {
  if (typeof window !== 'undefined' && window.shopify?.idToken) return window.shopify.idToken();
  const dev = import.meta.env.VITE_DEV_SESSION_TOKEN as string | undefined;
  if (dev) return dev;
  throw new ApiError(401, 'Open this app from Shopify admin');
}

export async function api<T = unknown>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const token = await sessionToken();
  const res = await fetch(`/admin/api${path}`, {
    method: init.method ?? (init.body !== undefined ? 'POST' : 'GET'),
    headers: {
      Authorization: `Bearer ${token}`,
      ...(init.body !== undefined ? { 'Content-Type': 'application/json' } : {}),
    },
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) throw new ApiError(res.status, data?.error ?? `Request failed (${res.status})`);
  return data as T;
}

export function toast(message: string, isError = false) {
  if (window.shopify?.toast) window.shopify.toast.show(message, { isError });
  else console[isError ? 'error' : 'info'](message);
}
